module.exports = __webpack_public_path__ + "static/1-161c45b5ab6df4eda570c8ac7d761aaf.jpg";